import { useNavigate } from "react-router";
import styled, { css, keyframes } from "styled-components";
import Logo from "../sharable/Logo";
import { useEffect, useState } from "react";
import {
  arrowDown,
  arrowDownCircleOutline,
  arrowForward,
  arrowForwardCircleOutline,
  checkmarkCircle,
  chevronForwardOutline,
  logoInstagram,
  logoWhatsapp,
  logoYoutube,
  mailOutline,
  star,
} from "ionicons/icons";
import { IonIcon } from "@ionic/react";
import Help from "../sharable/Help";
const Container = styled.main`
  width: 100vw;
  #212121;

  overflow-x: hidden;
  /* Initial state (hidden below) */
.slide-up-element-js {
    opacity: 0;
    transform: translateY(5rem);
    transition: opacity 800ms ease-out, transform 800ms ease-out; /* Define the transition properties */
}

/* Final state (visible and in place) */
.slide-up-element-js.is-visible {
    opacity: 1;
    transform: translateY(0);
}
`;

const SectionTitle = styled.h2`
  font-size: 4.8rem;
  text-align: center;
  margin-bottom: 2rem;
  @media (max-width: 600px) {
    font-size: 4.2rem;
  }
`;

const SectionStyles = css`
  padding: 7.2rem 9.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  @media (max-width: 1200px) {
    padding: 3.6rem 5.2rem;
  }

  @media (max-width: 900px) {
    padding: 3.6rem 4.8rem;
  }

  @media (max-width: 600px) {
    padding: 4.8rem 3rem;
  }
`;

const SectionDescription = styled.p`
  font-size: 1.8rem;
  text-align: center;
`;

/*HERO SECTION */

const Menu = styled.ul`
  display: flex;
  list-style: none;
  width: 100%;
  justify-content: center;
  gap: 3.6rem;

  @media (max-width: 900px) {
    display: none;
  }
`;

const MenuHoverAnimation = css`
  span {
    display: block;
    position: absolute;
    border-radius: 50%;
  }

  /*TOP*/
  span:nth-child(1) {
    width: 100%;
    height: 3px;
    background: linear-gradient(90deg, transparent, #ffc179);
    top: 0;
    left: -100%;
  }
  &:hover {
    span:nth-child(1) {
      transition: 1s;
      left: 100%;
    }
  }

  /*RIGHT*/
  span:nth-child(2) {
    height: 100%;
    width: 3px;
    background: linear-gradient(180deg, transparent, #ffc179);
    top: -100%;
    right: 0;
  }
  &:hover {
    span:nth-child(2) {
      transition-delay: 5s;
      transition: 1s;
      top: 100%;
    }
  }

  /*BOTTOM*/
  span:nth-child(3) {
    width: 100%;
    height: 3px;
    background: linear-gradient(270deg, transparent, #ffc179);
    bottom: 0;
    right: -100%;
  }
  &:hover {
    span:nth-child(3) {
      transition-delay: 0.5s;
      transition: 1s;
      right: 100%;
    }
  }

  /*LEFT*/
  span:nth-child(4) {
    height: 100%;
    width: 3px;
    background: linear-gradient(360deg, transparent, #ffc179);
    bottom: -100%;
    left: 0;
  }
  &:hover {
    span:nth-child(4) {
      transition-delay: 0.75s;
      transition: 1s;
      bottom: 100%;
    }
  }
`;

const MenuItem = styled.li`
  overflow: hidden;
  position: relative;
  ${MenuHoverAnimation}

  span.menu-option {
    font-size: 2rem;
    cursor: pointer;
    position: relative;
    padding: 0.8rem;
    transition: color ease-in-out 300ms;
    height: min-content;
  }

  span.menu-option:hover {
    color: #ffc179;
  }
`;

const CTAButton = styled.button`
  all: unset;
  background-color: #d97706;
  border-radius: 1rem;
  padding: 2.4rem 3.6rem;
  font-size: 2.4rem;
  font-weight: bold;
  text-transform: uppercase;
  align-self: start;
  cursor: pointer;
  transition: all ease-in-out 300ms;
  position: relative;
  display: flex;
  align-items: center;
  gap: 2rem;
  overflow: hidden;

  color: #fff;

  /*  BUTTON ANIMATIONS  */
  &:hover {
    box-shadow:
      0 0 10px #ffc179,
      0 0 40px #ffc179,
      0 0 80px #ffc179;
  }

  &.second-cta {
    background-color: transparent;
    color: #824704;
  }

  &.second-cta:hover {
    box-shadow: none;
    color: #d97706;
  }

  @media (max-width: 1200px) {
    font-size: 2rem;
  }

  @media (max-width: 600px) {
    font-size: 3rem;
  }
`;

const Header = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: min-content 1fr min-content;
  justify-items: space-around;
  padding: 2.4rem 3.6rem;
  ${CTAButton} {
    background-color: transparent;
    border: 1px solid #d97706;
    padding: 1.6rem 2.4rem;
    box-shadow: none;
    color: #d97706;
    &:hover {
      background-color: #d97706;
      color: #fff;
      border-color: transparent;
    }
  }

  @media (max-width: 900px) {
    grid-template-columns: min-content min-content;
    align-items: center;
    justify-content: space-between;
    ${CTAButton} {
      font-size: 1.8rem;
      padding: 1.2rem 1.8rem;
    }
  }

  @media (max-width: 600px) {
    padding: 0 3.6rem;
  }
`;

const CtaWrapper = styled.div`
  display: flex;
  grid-column: 1/2;
  @media (max-width: 1200px) {
    margin-top: 3.6rem;
  }
  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
  }
`;

const HeroSection = styled.section`
  width: 100vw;
  padding: 3.6rem 5.4rem;
  background-color: #fbf1e6;
  color: #1B1B1B;
  @media (max-width: 1200px) {
    height: min-content;
    padding: 3.6rem 3.6rem;
  }

  @media (max-width: 900px) {
    ${CTAButton} {
      align-self: center;
    }
  }

    @media (max-width: 600px) {
    padding: 3.6rem 2.4rem;
  }
    padding: 0;
    padding-bottom: 3.6rem;
  }
`;

const HeroTitle = styled.h1`
  font-size: 6.6rem;
  line-height: 1.2;
  text-transform: uppercase;

  div {
    position: relative;
    display: inline-block;
  }

  div::after {
    content: "";
    background-image: url("images/landing/stroke.png");
    width: 35rem;
    height: 10rem;
    background-size: contain;
    position: absolute;
    bottom: -8.5rem;
    background-repeat: no-repeat;
    right: 0;

    @media (max-width: 1200px) {
      height: 8rem;
      width: 25rem;
      bottom: -7rem;
    }

    @media (max-width: 600px) {
      bottom: -7rem;
    }
  }

  @media (max-width: 1200px) {
    font-size: 5.4rem;
    margin-bottom: 3.6rem;
    margin-top: 7.2rem;
  }

  @media (max-width: 900px) {
    text-align: center;
    margin-bottom: 4.2rem;
  }

  @media (max-width: 600px) {
    font-size: 6.2rem;
  }
`;

const HeroDescription = styled.p`
  font-size: 2.4rem;
  grid-column: 1/2;
  text-align: left;
  align-self: start;
  margin-top: 2rem;

  @media (max-width: 1200px) {
    font-size: 2rem;
    margin-top: 1.4rem;
  }

  @media (max-width: 900px) {
    text-align: center;
  }

  @media (max-width: 600px) {
    text-align: center;
    font-size: 1.8rem;
  }
`;

const float = keyframes`
  0% { transform: translateY(0); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0); }
`;

const HeroImage = styled.div`
  background-image: url(images/landing/HERO-IMAGE-V2.png);
  width: 75rem;
  height: 75rem;
  background-size: cover;
  background-repeat: no-repeat;
  transition: all ease-in-out 300ms;
  cursor: pointer;
  grid-column: 2/3;
  grid-row: 1/-1;
  &:hover {
    transform: scale(1.1);
  }

  @media (max-width: 1200px) {
    width: 60rem;
    height: 60rem;
  }

  @media (max-width: 900px) {
    width: 75rem;
    height: 70rem;
    grid-column: 1/2;
    grid-row: 4/5;
  }

  @media (max-width: 600px) {
    width: 58rem;
    height: 58rem;
  }

  animation: ${float} 3s ease-in-out infinite;
`;

const HeroContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: min-content min-content min-content min-content;
  align-items: center;
  justify-content: start;
  padding: 3.6rem 7.2rem;
  @media (max-width: 900px) {
    justify-items: center;
    grid-template-columns: 1fr;
    padding: 2.4rem 14rem;
  }

  @media (max-width: 700px) {
    justify-items: center;
    grid-template-columns: 1fr;
    padding: 2.4rem 8rem;
  }

  @media (max-width: 600px) {
    padding: 2.4rem 1rem;
  }

  .generated-encartes {
    font-size: 1.6rem;
    grid-column: 1/2;
    align-self: start;
  }

  @media (max-width: 1200px) {
    .generated-encartes {
      margin-top: 1.6rem;
    }
  }

  @media (max-width: 600px) {
    .generated-encartes {
      margin-bottom: 3rem;
      text-align: center;
    }
  }
`;
const HeroCopyWrapper = styled.div`
  width: 50%;

  @media (max-width: 1200px) {
    width: 60%;
  }

  @media (max-width: 900px) {
    width: 80%;
  }
`;

const KnowHowItWorks = styled.span`
  @media (max-width: 900px) {
    margin-top: 3.6rem;
  }
  align-items: center;
  text-transform: uppercase;
  justify-content: center;
  gap: 0.8rem;
  font-size: 1.4rem;
  cursor: pointer;
  transition: color ease-in-out 200ms;
  align-self: center;
  .icon {
    font-size: 1.6rem;
  }

  &:hover {
    color: #ffc179;
  }

  @media (max-width: 600px) {
    display: none;
  }
`;

/* HOW IT WORKS SECTION */
const HowItWorksSection = styled.section`
  ${SectionStyles}
  background-color: #FFE2C0;
  width: 100%;
  position: relative;
  justify-content: center;
  align-items: center;
  ${SectionTitle} {
    color: #824704;
    line-height: 1;
    .number {
      font-size: 9.2rem;
      color: transparent;
      -webkit-text-stroke-color: #824704;
      -webkit-text-stroke-width: 2px;
    }
  }

  ${SectionDescription} {
    margin-bottom: 8rem;
  }
`;

const StepContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  gap: 3.6rem;
  color: #212121;
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    grid-templte-rows: min-content min-content min-content;
  }
`;
const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  h3 {
    font-size: 3rem;
    margin-bottom: 1.8rem;
    text-align: center;
  }

  p {
    font-size: 1.8rem;
    text-align: center;
  }

  @media (max-width: 600px) {
    h3,
    p {
      text-align: left;
      align-self: start;
    }
  }
`;

const StepIcon = styled.div`
  ${({ icon }) => `

background-image: url('${icon}');
`}
  background-size: contain;
  background-repeat: no-repeat;
  width: 8rem;
  height: 8rem;
  margin-bottom: 3rem;
`;

const HowItWorksImage = styled.div`
  background-image: url("");
  background-size: contain;
  background-repeat: no-repeat;
`;

/* EXCLUSIVE SECTION */

const ExclusiveSection = styled.section`
  ${SectionStyles}
  margin-top: 4.8rem;
`;

const BenefitsContainer = styled.div`
  margin-top: 5.6rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  gap: 4.8rem;
  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
    gap: 3.6rem;
  }

  @media (max-width: 600px) {
    gap: 2.4rem;
    grid-template-columns: 1fr;
  }
`;

const Benefit = styled.div`
  .title {
    font-size: 1.6rem;
    font-weight: bold;
    margin-bottom: 2rem;
    display: inline-block;
  }

  .description {
    display: inline-block;
    font-size: 1.2rem;
  }
  padding: 2.4rem 3.6rem;
  width: 40rem;
  height: 15rem;
  border-radius: 15px;
  box-shadow: 0 0 10px rgba(1, 1, 1, 0.3);
  background-color: #824704;
  transition: all ease-in-out 300ms;
  cursor: pointer;
  color: #fff;
  &:hover {
    transform: translateY(-2rem);
  }

  @media (max-width: 600px) {
    height: 20rem;
    width: 50rem;
    .title {
      font-size: 2.6rem;
    }
    .description {
      font-size: 1.8rem;
    }
  }
`;

// PHONE OPTIMIZED SECTION

const PhoneOptimizedSection = styled.section`
  padding: 7.2rem 9.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4.8rem;

  img {
    width: 30rem;
    border-radius: 2rem;
  }

  h2 {
    max-width: 60rem;
    font-size: 4.2rem;
    margin-bottom: 1.6rem;
    text-align: left;
  }

  p {
    font-size: 2rem;
    max-width: 70rem;
    margin-bottom: 2.4rem;
    text-align: left;
  }

  .icon.optimized-icon {
    color: #d97706 !important;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    gap: 5.4rem;
    h2 {
      line-height: 1.5;
      width: 100%;
    }
    img {
      width: 35rem;
    }
  }
`;
const PhoneImage = styled.img`
  width: 30rem;
  height: 60rem;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;

  @media (max-width: 600px) {
    width: 35rem;
    height: 70rem;
  }
`;

const PhoneImagePlaceholder = styled.div`
  background-color: #eee;
  border-radius: 2rem;
  width: 30rem;
  height: 60rem;

  @media (max-width: 600px) {
    width: 35rem;
    height: 70rem;
  }
`;

/* TESTEMONIAlS SECTION */

const TestemonialsSection = styled.section`
  ${SectionStyles}
  ${SectionDescription} {
    margin-bottom: 7.2rem;
  }
`;

const TestemonialsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  @media (max-width: 600px) {
    gap: 4.8rem;
    grid-template-columns: 1fr;
    width: 70%;
  }
`;

const StarsWrapper = styled.div`
  display: flex;
  gap: 0.6rem;
  font-size: 2rem;
  align-items: center;
  color: #d97706;
  margin-bottom: 3.6rem;
`;

const TestemonialPersonImage = styled.div`
  background-image: url(${({ image }) => image});
  background-size: cover;
  background-position: center;
  width: 8rem;
  height: 8rem;
  border-radius: 50%;
  border: 2px solid #d97706;
  margin-bottom: 2rem;
`;
const Testemonial = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 600px) {
    border: none;
  }
  border-right: 1px solid #7b7b7b;
  text-align: center;
  &&:nth-child(3) {
    border: none;
  }
  padding: 1.2rem 2.4rem;
  .name {
    font-weight: bold;
    color: #d97706;
    font-size: 1.8rem;
  }

  .business {
    font-size: 1.4rem;
    color: #7b7b7b;
  }

  .comment {
    font-size: 1.8rem;
    margin-bottom: 1.4rem;
  }
`;

/* PLANS SECTION */

const PlansSection = styled.section`
  ${SectionStyles}

  background-color: #FFE2C0;

  ${SectionTitle} {
    color: #824704;
  }
  ${SectionDescription} {
    margin-bottom: 9.2rem;
  }
`;

const PlansContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 4.2rem;
  justify-items: center;
  justify-content: center;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 3rem;
  }

  @media (max-width: 650px) {
    gap: 5.4rem;
    flex-direction: column;
    display: flex;
    align-items: center;
  }
`;

const Plan = styled.div`
  min-height: 60rem;
  max-width: 40rem;
  width: 35rem;
  display: flex;
  flex-direction: column;
  padding: 3rem 2.4rem;
  align-items: center;
  //border: 1px solid #824704;
  border-radius: 10px;
  ${CTAButton} {
    text-align: center;
    align-self: center;
    margin-bottom: 3.6rem;
    background-color: transparent;
    border: 1px solid #824704;
    color: #824704;
    &:hover {
      box-shadow: none;
      background-color: #824704;
      color: #fff;
    }
  }
  .name {
    font-size: 2rem;
    margin-bottom: 2rem;
    font-weight: bold;
  }

  .price {
    font-size: 7.2rem;
    font-weight: bold;
    margin-bottom: 1.4rem;
    color: #824704;
    .cifrao {
      font-size: 2rem;
    }
  }

  &&.premium-plan {
    transform: translateY(-5rem);
    color: #fff;
    background-color: #d97706;
    ${CTAButton} {
      background-color: #824704;
      color: #fff;

      &:hover {
        background-color: #d97706;
        color: #824704;
      }
    }

    .price {
      color: #fff;
    }

    li .icon {
      color: #fff;
    }

    @media (max-width: 600px) {
      transform: translateY(0);
    }
  }

  &&.trimestral {
    min-height: 40rem;
  }

  &&.anual {
  border: 1px solid #824704;
  @media (max-width: 600px) {
  
  grid-column: 1/-1;
  }
     ${CTAButton} {
      background-color: #824704;
      color: #fff;

      &:hover {
        background-color: #d97706;
        color: #824704;
      }
  }
`;

const FeatureContainer = styled.ul`
  list-style: none;
  gap: 1rem;
  display: flex;
  flex-direction: column;
  .includes {
    font-size: 2rem;
    font-weight: 600;
    span {
      grid-column: 1/3;
    }
  }

  li {
    font-size: 1.6rem;
    display: grid;
    gap: 1rem;
    align-items: center;
    grid-template-columns: min-content 1fr;
    grid-template-rows: 1fr;
  }

  li .icon {
    font-size: 2rem;
    color: #824704;
  }

  li.bonus {
    background-color: #d97706;
    border: 1px solid #d97706;
    border-radius: 0.8rem;
    padding: 0.8rem 1rem;
    font-weight: 600;
    color: #ffffff;
  }

  li.bonus .icon {
    color: #ffffff;
  }
`;

/* KNOW INSIDE SECTION */

const KnowInsideSection = styled.section`
  ${SectionStyles}
`;

const VideoWrapper = styled.div`
  width: 100%;
  max-width: 100rem;
  margin: 3rem auto;
  aspect-ratio: 16/9;
  background: #000;
  border-radius: 1.2rem;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(1, 1, 1, 0.12);

  iframe {
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 1.2rem;
    background: #000;
    display: block;
  }
`;

/* FAQ SECTION */

const FAQSection = styled.section`
  ${SectionStyles}

  ${SectionDescription} {
    margin-bottom: 7.2rem;
  }
`;

const AccordionContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 3rem;
  width: 100%;
  justify-items: center;
`;

const Accordion = styled.div`
  cursor: pointer;
  box-shadow: 0 0 10px rgba(1, 1, 1, 0.08);
  padding: 2rem;
  border-radius: 10px;
  width: 80%;
  height: min-content;
  .icon {
    transition: all ease-in-out 300ms;
    font-size: 2rem;
  }
  .question-icon-wrapper {
    display: grid;
    grid-template-columns: 1fr min-content;
    align-items: center;
  }
  .question {
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 2rem;
    display: inline-block;
  }

  .answer {
    font-size: 1.4rem;
  }

  &&.opened {
    .icon {
      transform: rotate(90deg);
    }
  }
`;

/* CTA Section */

const CTASection = styled.div`
${SectionStyles}
background-color: #d97706;
color #fff;
background-image: url("images/cta-bg.png");
width: 100%;
height: min-content;
background-size: cover;
color: #fff;
display:grid;
grid-template-columns: 40% 60%;
${SectionTitle} {
   width: 70%;
  margin-bottom: 7.2rem;
  position: relative;

    span::after {
    content: "";
    background-image: url("images/landing/stroke.png");
    width: 40rem;
    height: 5rem;
    background-size: contain;
    position: absolute;
    bottom: -5rem;
    background-repeat: no-repeat;
    right: 0;
      @media (max-width: 600px) {
   
      right: 50%;
      transform: translateX(50%);

  }
  }
} 
${CTAButton} {
    align-self: center;
    background-color: #fbf1e6;
    color: #824704;
    transition: all ease-in-out 300ms;
    &:hover {
      background-color: #824704;
      color: #ffffff;
}
    }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-template-rows: min-content min-content;
    justify-items: center;

    ${SectionTitle} {
      font-size: 4.8rem;
      width: 80%;
    }
  }

  @media (max-width: 600px) {
      ${SectionTitle} {
      width: 100%;
    }
  }
`;

const CtaContentWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  align-items: center;
`;

const CTAImage = styled.img`
  width: 50rem;
  height: 50rem;
  background-size: contain;
  background-repeat: no-repeat;
`;

/* FOOTER */

const Footer = styled.div`
  ${SectionStyles};
  background-color: #212121;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  justify-content: center;
  justify-items: center;
  align-items: start;
  color: #fff;
  @media (max-width: 600px) {
    grid-template-columns: 1fr 1fr;
    row-gap: 3.6rem;
  }
`;

const FooterOptions = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  gap: 1.2rem;
  .title {
    font-weight: bold;
    font-size: 1.6rem;
    margin-bottom: 1rem;
  }

  a {
    all: unset;
  }
  li:not(.title) {
    cursor: pointer;
    font-size: 1.4rem;
    transition: all ease-in-out 200ms;
  }

  li:not(.title):hover {
    color: #d97706;
  }
`;

const BusinessInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const FooterSocialContainer = styled.div`
  margin-top: 4.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.4rem;
  .icon {
    cursor: pointer;
    transition: all ease-in-out 200ms;
    font-size: 3rem;
  }

  a {
    all: unset;
  }

  .icon:hover {
    color: #d97706;
  }

  .icon::after {
    ${({ content }) => `content: ${content}`}
  }
`;

export default function LandingPageView() {
  const [openedFAQ, setOpenedFAQ] = useState(undefined);
  const [loadPhoneImage, setLoadPhoneImage] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    // Save previous root font-size
    const prevFontSize = document.documentElement.style.fontSize;
    // Set responsive font-size for landing page
    function setFontSize() {
      let size = 10;
      if (window.innerWidth < 600) size = 6;
      else if (window.innerWidth < 800) size = 7;
      else if (window.innerWidth < 1200) size = 8;
      else if (window.innerWidth < 1500) size = 9;
      document.documentElement.style.fontSize = `${size}px`;
    }
    setFontSize();
    window.addEventListener("resize", setFontSize);

    // Cleanup: restore previous font-size
    return () => {
      document.documentElement.style.fontSize = prevFontSize || "";
      window.removeEventListener("resize", setFontSize);
    };
  }, []);
  const scrollIntoSection = (sectionId) => {
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleAuthRedirect = (path) => {
    // Save current path to sessionStorage
    sessionStorage.setItem(
      "redirectAfterAuth",
      window.location.pathname + window.location.search,
    );
    navigate(path);
  };
  useEffect(() => {
    const slideUpElements = document.querySelectorAll(".slide-up-element-js");

    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.2,
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    slideUpElements.forEach((element) => {
      observer.observe(element);
    });
  }, []);
  return (
    <Container className="flex direction-column">
      <Help showGroup={false} showYoutube={false} />
      <HeroSection className="flex direction-column" id="hero">
        <Header>
          <Logo size={12} />
          <Menu>
            <MenuItem
              onClick={() => {
                scrollIntoSection("how-it-works");
              }}
            >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span className="menu-option">Como funciona</span>
            </MenuItem>

            <MenuItem
              onClick={() => {
                scrollIntoSection("exclusive");
              }}
            >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span className="menu-option">Diferenciais</span>
            </MenuItem>

            <MenuItem
              onClick={() => {
                scrollIntoSection("testemonials");
              }}
            >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span className="menu-option">clientes</span>
            </MenuItem>

            <MenuItem
              onClick={() => {
                scrollIntoSection("plans");
              }}
            >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span className="menu-option">planos</span>
            </MenuItem>
            <MenuItem
              onClick={() => {
                scrollIntoSection("faq");
              }}
            >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span className="menu-option">Dúvidas Frequentes</span>
            </MenuItem>
          </Menu>
          <CTAButton onClick={() => navigate("/entrar")}>Entrar</CTAButton>
        </Header>
        <HeroContentWrapper className="">
          <dev>
            <HeroTitle>
              Gere encartes que{" "}
              <div>
                <span>vendem, </span>
              </div>{" "}
              em minutos!
            </HeroTitle>
          </dev>
          <HeroDescription>
            Pare de gastar tempo e dinheiro criando encartes que{" "}
            <strong>NÃO CONVERTEM.</strong> Com planos a partir de R$24,90 você
            cria encartes profissionais em minutos, mesmo{" "}
            <strong>SEM EXPERIÊNCIA</strong>.
          </HeroDescription>

          <CtaWrapper className="flex min-gap cta-wrapper">
            <CTAButton onClick={() => navigate("/registrar")}>
              Iniciar teste Grátis
              <IonIcon icon={arrowForward} className="icon" />
            </CTAButton>
            <CTAButton
              onClick={() => {
                scrollIntoSection("plans");
              }}
              className="second-cta"
            >
              Ver planos
              <IonIcon icon={arrowDown} className="icon" />
            </CTAButton>
          </CtaWrapper>
          <span className="generated-encartes">
            +25.000 encartes gerados para + 1000 negócios.
          </span>
          <HeroImage />
        </HeroContentWrapper>
        <KnowHowItWorks
          className="flex"
          onClick={() => scrollIntoSection("how-it-works")}
        >
          <IonIcon className="icon" icon={arrowDownCircleOutline} />
          conheça melhor o nosso serviço
        </KnowHowItWorks>
      </HeroSection>
      <HowItWorksSection id="how-it-works">
        <SectionTitle className="slide-up-element-js">
          Seu encarte em <span className="number">3</span> passos simples
        </SectionTitle>
        <SectionDescription className="slide-up-element-js">
          Criação de encartes simplificada para você montar em até 2 minutos
        </SectionDescription>
        <StepContainer className="flex slide-up-element-js">
          <Step>
            <StepIcon icon={"icons/add-product-icon.png"} />
            <h3>1. Adicione seus produtos</h3>
            <p>
              Adicione nome, preço e busque pela imagem do seu produto. Você
              também pode adicionar produtos cadastrados com apenas 1 clique.
            </p>
          </Step>
          <Step>
            <StepIcon icon={"icons/choose-icon.png"} />
            <h3>2. Escolha o tema </h3>
            <p>
              Escolha entre diversos temas profissionais disponíveis. Seja seu
              negócio açougue, hortifruti ou mercado, temos diversos modelos
              para o seu segmento.
            </p>
          </Step>
          <Step>
            <StepIcon icon={"icons/style-icon.png"} />
            <h3>3. Estilize </h3>
            <p>
              Personalize cores, fontes, layouts e etiquetas para deixar o
              encarte do seu estilo.
            </p>
          </Step>
        </StepContainer>
      </HowItWorksSection>{" "}
      <ExclusiveSection id="exclusive">
        <SectionTitle className="slide-up-element-js">
          O que você ganha?
        </SectionTitle>
        <SectionDescription className="slide-up-element-js">
          Conheça os benefícios de ter uma ferramenta profissional para criação
          de encartes como OfertasExpress
        </SectionDescription>
        <BenefitsContainer className="slide-up-element-js">
          <Benefit>
            <span className="title">Economize tempo e dinheiro</span>
            <p className="description">
              Você não precisa mais gastar dinheiro com Designer e ainda
              precisar aguardar longos prazos de entrega.
            </p>
          </Benefit>
          <Benefit>
            <span className="title">Aumento das vendas</span>
            <p className="description">
              Seus clientes só irão comprar de você se eles souberem de suas
              ofertas. Monte encartes atrativos que chamem a atenção.
            </p>
          </Benefit>
          <Benefit>
            <span className="title">Temas profissionais e exclusivos</span>
            <p className="description">
              Tenha acesso a temas modernos e prontos para uso, criados por
              Designer profissional.
            </p>
          </Benefit>
          <Benefit>
            <span className="title">Personalizável</span>
            <p className="description">
              Mantenha a identidade da sua marca. Adicione o endereço do seu
              negócio, redes sociais e seu logo.
            </p>
          </Benefit>
          <Benefit>
            <span className="title">Interface Intuitiva</span>
            <p className="description">
              Interface simples e limpa para você não se perder na hora de
              montar o seu encarte.
            </p>
          </Benefit>
          <Benefit>
            <span className="title">Acesse de qualquer lugar</span>
            <p className="description">
              Crie seus encartes onde estiver, seja por celular ou computador.
            </p>
          </Benefit>
        </BenefitsContainer>
      </ExclusiveSection>
      <PhoneOptimizedSection className="flex justify">
        <div className="flex direction-column justify">
          <h2 className="slide-up-element-js">
            Plataforma 100% otimizada para celular
          </h2>
          <p className="slide-up-element-js">
            Mais de 90% dos nossos usuários acessam a plataforma pelo celular.
            De qualquer lugar, a qualquer hora.
          </p>
          <FeatureContainer className="slide-up-element-js">
            <li>
              <IonIcon icon={checkmarkCircle} className="icon optimized-icon" />
              Interface simples e intuitiva
            </li>

            <li>
              <IonIcon icon={checkmarkCircle} className="icon optimized-icon" />
              Velocidade no carregamento
            </li>
          </FeatureContainer>
        </div>
        <PhoneImage
          className="slide-up-element-js"
          src="images/landing/Celular.png"
          loading="lazy"
        />
      </PhoneOptimizedSection>
      <TestemonialsSection id="testemonials">
        <SectionTitle className="slide-up-element-js">
          O que nossos clientes dizem
        </SectionTitle>
        <SectionDescription className="slide-up-element-js">
          Veja o que nossos clientes tem a falar sobre nosso serviço
        </SectionDescription>
        <TestemonialsContainer className="slide-up-element-js">
          <Testemonial>
            <TestemonialPersonImage image="images/landing/t1.jpg" />
            <StarsWrapper>
              <IonIcon icon={star} />
              <IonIcon icon={star} />
              <IonIcon icon={star} />
              <IonIcon icon={star} />
              <IonIcon icon={star} />
            </StarsWrapper>
            <p className="comment">
              "Suporte técnico rápido e eficiente. Obrigado!""
            </p>
            <span className="name">Francisco Aguiar</span>
            <span className="business">Dono de mercadinho</span>
          </Testemonial>
          <Testemonial>
            <TestemonialPersonImage image="images/landing/t2.jpg" />
            <StarsWrapper>
              <IonIcon icon={star} />
              <IonIcon icon={star} />
              <IonIcon icon={star} />
              <IonIcon icon={star} />
              <IonIcon icon={star} />
            </StarsWrapper>
            <p className="comment">
              "Muito top os encartes, já vou começar a usar hoje mesmo. Essa
              plataforma de encarte ajuda todos nós da área de vendas e afins.
              Obrigado."
            </p>
            <span className="name">Pedro Antônio</span>
            <span className="business">Dono de mercado</span>
          </Testemonial>
          <Testemonial>
            <TestemonialPersonImage image="images/landing/t3.jpg" />
            <StarsWrapper>
              <IonIcon icon={star} />
              <IonIcon icon={star} />
              <IonIcon icon={star} />
              <IonIcon icon={star} />
              <IonIcon icon={star} />
            </StarsWrapper>
            <p className="comment">
              "Plataforma top demais! Estou satisfeito em todos os dias poder
              criar os meus encartes."
            </p>
            <span className="name">José Risomar</span>
            <span className="business">Dono de açougue</span>
          </Testemonial>
        </TestemonialsContainer>
      </TestemonialsSection>
      <PlansSection id="plans">
        <SectionTitle className="slide-up-element-js">
          Quanto custa o OfertasExpress?
        </SectionTitle>
        <SectionDescription className="slide-up-element-js">
          Planos que cabem no seu bolso
        </SectionDescription>
        <PlansContainer className="slide-up-element-js">
          <Plan className="trimestral">
            <span className="name">Teste Grátis</span>
            <span className="price">
              <span className="cifrao"></span>GRÁTIS
            </span>
            <CTAButton onClick={() => navigate("/registrar")}>
              iniciar
            </CTAButton>
            <FeatureContainer>
              <li className="includes">
                <span>O que está incluso:</span>
              </li>

              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Conheça toda nossa plataforma</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Acesso por 24 horas</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Todos os temas</span>
              </li>
            </FeatureContainer>
          </Plan>
          <Plan className="basic">
            <span className="name">Básico Mensal</span>
            <span className="price">
              <span className="cifrao">R$</span>24,90
            </span>
            <CTAButton
              onClick={() =>
                handleAuthRedirect(
                  "/metodo-pagamento?lookup_key=MONTHLY_BASIC_PLAN",
                )
              }
            >
              adquirir
            </CTAButton>
            <FeatureContainer>
              <li className="includes">
                <span>O que está incluso:</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Mais de 80 temas disponíveis</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>3 encartes por dia</span>
              </li>
            </FeatureContainer>
          </Plan>
          <Plan className="premium-plan">
            <span className="name">Premium Mensal</span>
            <span className="price">
              <span className="cifrao">R$</span>39,90
            </span>
            <CTAButton
              onClick={() =>
                handleAuthRedirect(
                  "/metodo-pagamento?lookup_key=MONTHLY_PREMIUM_PLAN",
                )
              }
            >
              adquirir
            </CTAButton>
            <FeatureContainer>
              <li className="includes">
                <span>O que está incluso:</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Temas novos toda semana</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Monte em até 2 minutos</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Formato cartaz para impressão</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Diferentes grades de produtos</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Compartilhe direto para as redes</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Criações ilimitadas</span>
              </li>
            </FeatureContainer>
          </Plan>
          <Plan className="trimestral">
            <span className="name">Premium Trimestral</span>
            <span className="price">
              <span className="cifrao">R$</span>109,90
            </span>
            <CTAButton
              onClick={() =>
                handleAuthRedirect(
                  "/metodo-pagamento?lookup_key=TRIMESTER_PREMIUM_PLAN",
                )
              }
            >
              adquirir
            </CTAButton>
            <FeatureContainer>
              <li className="includes">
                <span>O que está incluso:</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Temas novos toda semana</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Monte em até 2 minutos</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Formato cartaz para impressão</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Diferentes grades de produtos</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Compartilhe direto para as redes</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Criações ilimitadas</span>
              </li>
            </FeatureContainer>
          </Plan>
          <Plan className="trimestral">
            <span className="name">Premium Semestral</span>
            <span className="price">
              <span className="cifrao">R$</span>209,90
            </span>
            <CTAButton
              onClick={() =>
                handleAuthRedirect(
                  "/metodo-pagamento?lookup_key=SEMESTER_PREMIUM_PLAN",
                )
              }
            >
              adquirir
            </CTAButton>
            <FeatureContainer>
              <li className="includes">
                <span>O que está incluso:</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Temas novos toda semana</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Monte em até 2 minutos</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Formato cartaz para impressão</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Diferentes grades de produtos</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Compartilhe direto para as redes</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Criações ilimitadas</span>
              </li>
              <li className="bonus">
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Brinde: tema exclusivo</span>
              </li>
            </FeatureContainer>
          </Plan>
          <Plan className="trimestral anual ">
            <span className="name">Premium Anual</span>
            <span className="price">
              <span className="cifrao">R$</span>399,00
            </span>
            <CTAButton
              onClick={() =>
                handleAuthRedirect(
                  "/metodo-pagamento?lookup_key=YEARLY_PREMIUM_PLAN",
                )
              }
            >
              adquirir
            </CTAButton>
            <FeatureContainer>
              <li className="includes">
                <span>O que está incluso:</span>
              </li>
              <li className="bonus">
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Ganhe 2 meses grátis no plano anual</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Temas novos toda semana</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Monte em até 2 minutos</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Formato cartaz para impressão</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Diferentes grades de produtos</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Compartilhe direto para as redes</span>
              </li>
              <li>
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Criações ilimitadas</span>
              </li>
              <li className="bonus">
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Brinde: tema exclusivo</span>
              </li>
              <li className="bonus">
                <IonIcon icon={checkmarkCircle} className="icon" />
                <span>Brinde: Vídeo oferta</span>
              </li>
            </FeatureContainer>
          </Plan>
        </PlansContainer>
      </PlansSection>
      <KnowInsideSection>
        <SectionTitle className="slide-up-element-js">
          Conheça nossa plataforma por dentro
        </SectionTitle>
        <SectionDescription className="slide-up-element-js">
          Nesse vídeo apresentamos todas as funcionalidades da plataforma.
        </SectionDescription>
        <VideoWrapper className="slide-up-element-js">
          <iframe
            src="https://www.youtube.com/embed/1kN-Wtn4vfY"
            title="Conheça a plataforma"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            loading="lazy"
          />
        </VideoWrapper>
      </KnowInsideSection>
      <FAQSection id="faq">
        <SectionTitle className="slide-up-element-js">
          Dúvidas frequentes
        </SectionTitle>
        <SectionDescription className="slide-up-element-js">
          Organizamos as dúvidas mais frequentes para te ajudar :)
        </SectionDescription>

        <AccordionContainer className="slide-up-element-js">
          <Accordion
            onClick={() => {
              if (openedFAQ === 0) setOpenedFAQ(undefined);
              else setOpenedFAQ(0);
            }}
            className={`${openedFAQ === 0 && "opened"}`}
          >
            <div className="question-icon-wrapper">
              <span className="question">
                Preciso ter conhecimento em design para usar a plataforma?
              </span>{" "}
              <IonIcon icon={chevronForwardOutline} className="icon" />
            </div>
            {openedFAQ === 0 && (
              <p className="answer">
                Não! A Ofertas Express foi desenvolvida para ser extremamente
                intuitiva. Com nossa interface de fácil entendimento e modelos
                prontos, qualquer pessoa consegue criar encartes profissionais.
              </p>
            )}
          </Accordion>
          <Accordion
            onClick={() => {
              if (openedFAQ === 1) setOpenedFAQ(undefined);
              else setOpenedFAQ(1);
            }}
            className={`${openedFAQ === 1 && "opened"}`}
          >
            <div className="question-icon-wrapper">
              <span className="question">
                Quais tipos de negócios podem usar a Ofertas Express?
              </span>{" "}
              <IonIcon icon={chevronForwardOutline} className="icon" />
            </div>
            {openedFAQ === 1 && (
              <p className="answer">
                Nossa plataforma é ideal para supermercados, farmácias,
                açougues, padarias, hortifrutis, lojas de conveniência e
                qualquer negócio que precise divulgar ofertas de forma eficiente
              </p>
            )}
          </Accordion>
          <Accordion
            onClick={() => {
              if (openedFAQ === 2) setOpenedFAQ(undefined);
              else setOpenedFAQ(2);
            }}
            className={`${openedFAQ === 2 && "opened"}`}
          >
            <div className="question-icon-wrapper">
              <span className="question">
                Posso adicionar meu logo ao encarte?
              </span>{" "}
              <IonIcon icon={chevronForwardOutline} className="icon" />
            </div>
            {openedFAQ === 2 && (
              <p className="answer">
                Sim, totalmente! Não apenas o seu logo mas também suas redes
                sociais e endereço do seu negócio.
              </p>
            )}
          </Accordion>
          <Accordion
            onClick={() => {
              if (openedFAQ === 3) setOpenedFAQ(undefined);
              else setOpenedFAQ(3);
            }}
            className={`${openedFAQ === 3 && "opened"}`}
          >
            <div className="question-icon-wrapper">
              <span className="question">
                Preciso baixar algum aplicativo para utilizar?
              </span>{" "}
              <IonIcon icon={chevronForwardOutline} className="icon" />
            </div>
            {openedFAQ === 3 && (
              <p className="answer">
                Não! Ofertas Express é um site e você não precisa ocupar a
                memória do seu celular baixando aplicativo.
              </p>
            )}
          </Accordion>
          <Accordion
            onClick={() => {
              if (openedFAQ === 4) setOpenedFAQ(undefined);
              else setOpenedFAQ(4);
            }}
            className={`${openedFAQ === 4 && "opened"}`}
          >
            <div className="question-icon-wrapper">
              <span className="question">
                Vocês quem montam os encartes para mim?
              </span>{" "}
              <IonIcon icon={chevronForwardOutline} className="icon" />
            </div>
            {openedFAQ === 4 && (
              <p className="answer">
                Não! Nossa plataforma foi criada para que você mesmo possa criar
                seus encartes de forma rápida e prática.
              </p>
            )}
          </Accordion>
        </AccordionContainer>
      </FAQSection>
      <CTASection>
        <CTAImage
          className="slide-up-element-js"
          loading="lazy"
          src="images/landing/all-formats.png"
        />
        <CtaContentWrapper>
          <SectionTitle className="slide-up-element-js">
            Comece a vender mais hoje mesmo com OfertasExpress
          </SectionTitle>
          <CTAButton
            onClick={() => navigate("/registrar")}
            className="slide-up-element-js"
          >
            quero testar grátis <IonIcon icon={arrowForward} className="icon" />
          </CTAButton>
        </CtaContentWrapper>
      </CTASection>
      <Footer>
        <BusinessInfo className="business-info">
          <Logo color={"white"} size="15" />
          <FooterSocialContainer>
            <a href="https://wa.me/message/P2257KJYU5EZH1" target="_blank">
              <IonIcon icon={logoWhatsapp} className="icon" />
            </a>

            <a
              href="https://instagram.com/ofertasexpressoficial"
              target="_blank"
            >
              <IonIcon icon={logoInstagram} className="icon" />
            </a>
            <a href="https://www.youtube.com/@ofertas-uo3nv" target="_blank">
              <IonIcon icon={logoYoutube} className="icon" />
            </a>
            <a href="mailto:kenedylima.developer@gmail.com">
              <IonIcon icon={mailOutline} className="icon" />
            </a>
          </FooterSocialContainer>
        </BusinessInfo>

        <FooterOptions>
          <li className="title">Navegação</li>
          <li onClick={() => scrollIntoSection("hero")}>Início</li>
          <li onClick={() => scrollIntoSection("how-it-works")}>
            Como funciona
          </li>
          <li onClick={() => scrollIntoSection("exclusive")}>Benefícios</li>
          <li onClick={() => scrollIntoSection("plans")}>Planos</li>
          <li onClick={() => scrollIntoSection("faq")}>FAQ</li>
        </FooterOptions>

        <FooterOptions>
          <li className="title">Acesso Rápido</li>
          <li onClick={() => navigate("/registrar")}>Criar conta</li>
          <li onClick={() => navigate("/entrar")}>Entrar</li>
          <li onClick={() => handleAuthRedirect("/encartes")}>Meus encartes</li>
          <li onClick={() => handleAuthRedirect("/minha-conta")}>
            Minha conta
          </li>
        </FooterOptions>

        <FooterOptions>
          <li className="title">Outros serviços</li>
          <a href="https://wa.me/message/P2257KJYU5EZH1" target="_blank">
            <li>Vídeo oferta</li>
          </a>
        </FooterOptions>
      </Footer>
    </Container>
  );
}
